import React from 'react';
import logo from './logo.svg';
import './App.css';
import Controller from './components/Controller';
import SupabaseAuth from './components/SupabaseAuth';
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from 'recoil';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import AddGcode from './components/AddGcode';

import PrintDataListPage  from './page_components/PrintDataPage';
import AddPrintDataPage from './page_components/AddPrintDataPage';
import PrinterPage from './page_components/PrinterPage';
import AddPrinterPage from './page_components/AddPrinterPage'
import QueueListPage from './page_components/QueueListPage';

function App() {


  return (
    <RecoilRoot>
        <SupabaseAuth>
          <BrowserRouter>
            <Routes>
              <Route path={`/`} element={ <PrintDataListPage />} />
              <Route path={`/add-printdata`} element={ <AddPrintDataPage />} />
              <Route path={"/printer"} element={<PrinterPage />} />
              <Route path={"/add-printer"} element={<AddPrinterPage />} />
              <Route path={"/queue"} element={<QueueListPage />} />
            </Routes>
          </BrowserRouter>

        </SupabaseAuth>

    </RecoilRoot>
  );
}

export default App;
